// Helper function to extract error messages from API responses
export const getErrorMessage = (error) => {
  if (!error.response) {
    return 'Erro de conexão. Verifique sua internet.';
  }

  const data = error.response.data;
  
  // Handle Pydantic validation errors (array of error objects)
  if (Array.isArray(data.detail)) {
    const messages = data.detail.map(err => {
      const field = err.loc?.[err.loc.length - 1] || 'campo';
      return `${field}: ${err.msg}`;
    });
    return messages.join(', ');
  }
  
  // Handle string errors
  if (typeof data.detail === 'string') {
    return data.detail;
  }
  
  // Handle object errors
  if (typeof data.detail === 'object' && data.detail !== null) {
    if (data.detail.msg) {
      return data.detail.msg;
    }
    return JSON.stringify(data.detail);
  }
  
  return 'Erro ao processar requisição';
};
